export const InscripcionProveedoresLang = {
    Titulo: {
      es: 'FORMATO DE INSCRIPCIÓN DE PROVEEDORES',
      en: 'VENDOR INSCRIPTION FORM',
    },

    codigoProveedor: {
      es: 'Código de proveedor',
      en: 'Vendor code',
    },

    informacionEmpresaTitle: {
      es: 'Información de la Empresa',
      en: 'Company information',
    },
    'NombreComercial': {
      'es': 'Nombre Comercial',
      'en': 'Business Name'
    },
    'NumIdentificacionTributaria': {
      'es': 'Número de Identificación Tributaria',
      'en': 'Taxpayer Identification Number (TIN)'
    },
    'Pais': {
      'es': 'País',
      'en': 'Country'
    },
    'Estado': {
      'es': 'Estado / Región',
      'en': 'State / Region'
    },
    'Ciudad': {
      'es': 'Ciudad',
      'en': 'City'
    },
    'DireccionComercial': {
      'es': 'Dirección Comercial',
      'en': 'Commercial Address'
    },
    'TelefonoRef': {
        'es': 'Número de teléfono de referencia',
        'en': 'Reference phone number'
    },
    'Email': {
        'es': 'Correo electrónico',
        'en': 'Email'
    },
    'actividadEconomica': {
        'es': 'Principal actividad económica',
        'en': 'Main economic activity'
    },
    'TipoFacturacion': {
        'es': 'Tipo de Factura',
        'en': 'Invoice Type'
    },
    'nombreCasaMatriz': {
        'es': 'Nombre de la casa matriz',
        'en': 'Headquarters name'
    },
    'distCasaMatriz': {
        'es': 'Si es distinto al nombre comercial.',
        'en': 'If it is different from the commercial name.'
    },
    'direccionCasaMatriz': {
        'es': 'Dirección de la casa matriz',
        'en': 'Headquarters address'
    },
    'distDireccionComercial': {
        'es': 'Si es distinto de la Dirección Comercial.',
        'en': 'If it is different from the Commercial Address.'
    },

    'completarCamposObligatorios': {
        'es': 'Completar los campos obligatorios.',
        'en': 'Complete the required fields.'
    },

    'informacionContactoRepresentanteLegal': {
        'es': 'Información de contacto del representante legal',
        'en': 'Contact information of the legal representative'
    },
    'Nombre': {
        'es': 'Nombre',
        'en': 'Name'
    },
    'inforamcionContactoCuentasCobrar': {
        'es': 'Información de contacto de cuentas por cobrar',
        'en': 'Accounts Receivable Contact Information'
    },
    'numeroTelefono': {
        'es': 'Número de teléfono',
        'en': 'Phone number'
    },
    'informacionBancaria': {
        'es': 'Información bancaria',
        'en': 'Bank information'
    },
    mensajeConstanciaBancaria: {
      es: "Para poder procesar los pagos el banco debe enviar una constancia bancaria con la información de su cuenta al correo de administracion@ppf.com.hn",
      en: "In order to process payments, the bank must send a bank certificate with your account information to administracion@ppf.com.hn",
    },
    bancoPais: {
      es: "Banco País",
      en: "Bank country",
    },
    actualiceDatosBancarios: {
      es: "Actualice sus datos bancarios",
      en: "Update your bank information",
    },
    pagosCuentasRegistradas: {
      es: "Los pagos se realizarán únicamente a cuentas registradas a su nombre según su tipo:",
      en: "Payments will only be made to accounts registered under your name according to your type:",
    },
    empresasSociedadesCuenta: {
      es: "1.- Empresas (sociedades): Cuenta a nombre de la empresa.",
      en: "1.- Companies: Account under the company's name.",
    },
    personasNaturalesCuenta: {
      es: "2.- Personas naturales/comerciantes individuales: Cuenta a su nombre personal.",
      en: "2.- Natural persons/individual merchants: Account under their personal name.",
    },
    actualizacionObligatoriaLavado: {
      es: "Esta actualización es obligatoria por la Ley Contra el Lavado de Activos (Decreto 67-2013).",
      en: "This update is mandatory under the Anti-Money Laundering Law (Decree 67-2013).",
    },
    cuentaBancariaLempiras: {
      es: "Cuenta Bancaria en Lempiras",
      en: "Bank Account in Lempiras",
    },

    cuentaBancariaDolares: {
      es: "Cuenta Bancaria en Dólares",
      en: "Bank Account in Dollars",
    },
    elijaComoRecibirPagos: {
      es: "Elija cómo recibir sus pagos:",
      en: "Choose how to receive your payments:",
    },
    siCuentaNoBanco: {
      es: " Si su cuenta NO está en Banco Atlántida o Ficohsa",
      en: " If your account is NOT at Banco Atlántida or Ficohsa",
    },
    atencion: {
      es: "Atención:",
      en: "Attention:",
    },
    politicasFinancieras: {
      es: " Por políticas financieras, no hacemos transferencias a otros bancos excepto Atlántida/Ficohsa.",
      en: " Due to financial policies, we do not make transfers to other banks except Atlántida/Ficohsa.",
    },
    dosOpcionesRecibirDinero: {
      es: "Tiene dos opciones para recibir su dinero:",
      en: "You have two options to receive your money:",
    },
    opcion1: {
      es: "Opción 1:",
      en: "Option 1:",
    },
    opcion1Transferencia: {
      es: " Transferencia a instituciones bancarias distintas a Banco Atlántida o Ficohsa.",
      en: " Transfer to banking institutions other than Banco Atlántida or Ficohsa.",
    },
    aceptoDeduccionComision: {
      es: "Acepto la deducción de la comisión bancaria que aplique su banco.",
      en: "I accept the deduction of the bank commission applied by my bank.",
    },
    opcion2: {
      es: "Opción 2:",
      en: "Option 2:",
    },
    opcion2Cheque: {
      es: " Retiro de cheque en nuestras oficinas.",
      en: " Check pickup at our offices.",
    },
    aceptoPagoCheque: {
      es: "Acepto recibir pagos mediante cheque.",
      en: "I accept receiving payments by check.",
    },
    compromisos: {
      es: "Compromisos:",
      en: "Commitments:",
    },
    compromisoCheque1: {
      es: "1.- Un representante autorizado con identificación retirará el cheque personalmente.",
      en: "1.- An authorized representative with identification will personally pick up the check.",
    },
    compromisoCheque2: {
      es: "2.- El cheque se emitirá solo a nombre del titular registrado empresa o persona natural.",
      en: "2.- The check will only be issued under the registered account holder's name, whether company or natural person.",
    },
    debeSeleccionarOpcionPago: {
      es: "Debe seleccionar una opción de pago.",
      en: "You must select a payment option.",
    },
    confirmacionCuentaBancaria: {
      es: "Al enviar este formulario, usted confirma que:",
      en: "By submitting this form, you confirm that:",
    },
    confirmacionCuentaBancariaTexto: {
      es: " “La cuenta bancaria pertenece legalmente a mi empresa/persona y cumple con los requisitos de la Ley hondureña”.",
      en: " “The bank account legally belongs to my company/person and complies with the requirements of Honduran law”.",
    },
    completeDatosBancariosInternacionales: {
      es: "Complete sus datos bancarios internacionales",
      en: "Complete your international bank information",
    },
    
    importantePagosInternacionales: {
      es: "Importante para pagos internacionales:",
      en: "Important for international payments:",
    },
    
    pagosInternacionalesTexto: {
      es: " Los pagos se realizarán solo a cuentas registradas a nombre de su empresa según su tipo:",
      en: " Payments will only be made to accounts registered under your company's name according to your type:",
    },
    
    empresasSociedadesMercantiles: {
      es: "1.- Empresas sociedades mercantiles:",
      en: "1.- Business entities:",
    },
    
    cuentaNombreEmpresa: {
      es: " Cuenta a nombre de la empresa.",
      en: " Account under the company's name.",
    },
    
    personasNaturalesInternacional: {
      es: "2.- Personas naturales:",
      en: "2.- Natural persons:",
    },
    
    cuentaNombrePersonal: {
      es: " Cuenta a su nombre personal.",
      en: " Account under their personal name.",
    },
    
    confirmacionBancoInternacional: {
      es: "Al enviar este formulario, usted confirma que:",
      en: "By submitting this form, you confirm that:",
    },
    
    confirmacionBancoInternacionalTexto: {
      es: " “La información bancaria es correcta y cumple con las leyes antifraude de mi país.”",
      en: " “The bank information is correct and complies with the anti-fraud laws of my country.”",
    },
    'numeroCuenta': {
        'es': 'Número de cuenta',
        'en': 'Account number'
    },
    'titularCuenta': {
        'es': 'Titular de cuenta',
        'en': 'Account holder'
    },
    'Banco': {
        'es': 'Banco',
        'en': 'Bank'
    },
    'tipoCuenta': {
        'es': 'Tipo de cuenta',
        'en': 'Account type'
    },
    'Moneda': {
        'es': 'Moneda',
        'en': 'Currency'
    },
    'bancoIntermediario': {
        'es': 'Banco Intermediario',
        'en': 'Intermediary bank',
    },
    'bancoBeneficiario': {
        'es': 'Banco Beneficiario',
        'en': 'Beneficiary bank',
    },
    'Direccion': {
        'es': 'Dirección',
        'en': 'Address'
    },
    'Swift': {
        'es': 'Swift',
        'en': 'Swift'
    },
    'ABA / BIN': {
        'es': 'ABA / BIN',
        'en': 'ABA / BIN'
    },
    'nombreBeneficiario': {
        'es': 'Nombre del Beneficiario',
        'en': 'Beneficiary Name'
    },
    'referenciasComerciales': {
        'es': 'Referencias Comerciales',
        'en': 'Commercial references'
    },
    'Referencia': {
        'es': 'Referencia',
        'en': 'Reference'
    },
    'adjuntarDocumentos': {
        'es': 'Adjuntar los siguientes documentos.',
        'en': 'Attach the following documents.'
    },
    'Documentation': {
        'es': 'Documentación',
        'en': 'Documentation'
    },
    'PermisoOperaciones': {
        'es': 'Permiso de operaciones',
        'en': 'Operations permit'
    },
    'escrituraConstitucion': {
        'es': 'Escritura de constitución',
        'en': 'Articles of Incorporation'
    },
    'zonaLibre': {
        'es': 'Zona Libre',
        'en': 'Free zone'
    },
    'si': {
        'es': 'Si',
        'en': 'Yes'
    },
    'no': {
        'es': 'No',
        'en': 'No'
    },
    'nombreZona': {
        'es': 'Nombre Zona',
        'en': 'Zone Name'
    },
    'direccionZona': {
        'es': 'Dirección Zona',
        'en': 'Zone Address'
    },
    'registroExonerado': {
        'es': 'Registro exonerado',
        'en': 'Exempt registration'
    },
    'constPagosCuenta': {
        'es': 'Constancia de pagos a cuenta',
        'en': 'Proof of payments on account'
    },
    fechaInicio: {
      es: "Fecha Inicio",
      en: "Start Date",
    },

    fechaVencimiento: {
      es: "Fecha Vencimiento",
      en: "Expiration Date",
    },

    numeroRegistroExonerado: {
      es: "Número Registro Exonerado",
      en: "Exonerated Registration Number",
    },

    guardarRegistro: {
      es: "Guardar registro",
      en: "Save record",
    },

    noCuentaRegistroExoneradoVigente: {
      es: "No cuenta con registro exonerado vigente.",
      en: "Does not have a valid exonerated registration.",
    },
    'noPermiso': {
        'es': 'NO TIENES PERMISOS PARA VER ESTA PÁGINA',
        'en': 'YOU DO NOT HAVE PERMISSIONS TO VIEW THIS PAGE'
    },
    'autorizacionPagos': {
        es: ({ nombreEmpresa, nombreCorto }) =>
            `1) Por medio de la presente, declaramos que la información proporcionada en el presente formulario es correcta. Entendemos que “${nombreEmpresa}”, podrá contactar al departamento de cuentas por cobrar o contabilidad para su validación. Autorizamos a las empresas comerciales enumeradas en esta solicitud a proporcionar lo necesario para ayudar a “${nombreCorto}” a establecer una relación comercial con nosotros.

        2) Entendemos que la información bancaria proporcionada, ha sido verificada previo a ser compartida, por lo que “${nombreEmpresa}” podrá emitir pagos a las mismas sin responsabilidad alguna por errores de escritura, siempre y cuando se utilice la información completada por nosotros.`,

        en: ({ nombreEmpresa, nombreCorto }) =>
            `Hereby, we declare that the information provided in this form is correct. We understand that “${nombreEmpresa}” may contact the accounts receivable or accounting department for validation. We authorize the commercial companies listed in this application to provide what is necessary to help “${nombreCorto}” establish a commercial relationship with us.

        2) We understand that the banking information provided has been verified before being shared, therefore “${nombreEmpresa}” may issue payments without any responsibility for typing errors, as long as the information completed by us is used.`
    },
    'guardar': {
        'es': 'Guardar',
        'en': 'Save'
    },
    'guardar borrador': {
        'es': 'Guardar Borrador',
        'en': 'Save as Draft'
    },
    incompleta:{
        'es': 'Agregar información requerida',
        'en': 'Add required information'
    },
    
    'limpiar': {
        'es': 'Limpiar',
        'en': 'Clean'
    },
    'infCierta': {
        'es': 'La Información proporcionada en el presente formulario se considerará como cierta, por lo que nuestra responsabilidad únicamente se limita al analisis de la información proporcionada por el proveedor.',
        'en': 'The information provided in this form will be considered true, our accountability is limited to its analysis and validation only.'
    },
    'registroCompleto': {
        'es': 'Registro guardado correctamente.',
        'en': 'The information has been submitted successfully. '
    },
    'registroCompletoIncompleta': {
        'es': 'Borrador guardadado correctamente.',
        'en': 'Draft saved successfully.. '
    },
    'msgConfirmacion': {
        'es': '¿Estas seguro que deseas guardar la informacion?',
        'en': 'Are you sure about the entered information?'
    },
    'msgConfirmacionIncompleta': {
        'es': '¿Estas seguro que deseas guardar el borrador?',
        'en': 'Are you sure you want to save the draft?'
    },
    'msgNoEditable': {
        'es': 'Una vez que lo envíe, puede comunicarse con un agente de CSM para permitir el acceso nuevamente si se requiere alguna corrección.',
        'en': 'Once you send it, you may contact a PPF agent to allow access again if any correction is required.'
    },
    'msgNoEditableIncompleta': {
        'es': 'La inscripción se completará exitosamente una vez que haya proporcionado toda la información requerida.',
        'en': 'The registration will be successfully completed once you have provided all the required information.'
    },
    'paisConstitucion': {
        'es': 'País de constitución',
        'en': 'Country of incorporation'
    },
    'siEsDistintoAnterior': {
        'es': 'Si es distinto al anterior',
        'en': 'If different from the previous one'
    },
    'ContactoCuentasPorCobrar': {
        'es': 'Contacto de cuentas por cobrar (persona encargada de confirmar pagos)',
        'en': 'Accounts receivable contact (person in charge of confirming payments)'
    },
    'representanteLegal': {
        'es': 'Representante legal',
        'en': 'Legal representative'
    },
    'nombreCompañia': {
        'es': 'Nombre de la compañia',
        'en': 'Company name'
    },
    'TelefonoSmall': {
        'es': 'Tel.',
        'en': 'Phone'
    },
    'nombreBanco': {
        'es': 'Nombre del banco',
        'en': 'Bank name'
    },
    'direccionBanco': {
        'es': 'Dirección del banco',
        'en': 'Bank address'
    },
    'declaracion': {
        'es': 'Declaro que la información anterior es correcta. Entiendo que "Pride Performance Fabrics, S.A de C.V" podrá contactar y/o utilizar otras fuentes que le permitan investigar la información credicia que considere necesaria para este fin. Autorizamos a las empresas comerciales que figuran en esta solicitud a proveer lo necesario para ayudar a "Pride Performance Fabrics, S.A de C.V", a establecer una línea de crédito.',
        'en': 'I declare that the above information is correct. I understand that "Pride Performance Fabrics, S.A de C.V", may contact and / or use other sources to enable it to investigate credit information deemed necessary for this purpose. Autorize commercial companies listed in this application to disclose the necessary to help "Pride Performance Fabrics, S.A de C.V", to establish a line of credit.'
    },
    'msgContacto': {
        'es': '*Si tiene alguna duda con respecto a algún espacio, por favor escriba o llame al',
        'en': '*If you have any doubt regarding any blank to fill, please write or call to'
        
    },

    'msgValidacion': {
        'es': '*Esta información es muy importante. Los datos bancarios se validarán mediante llamada telefónica al recibir el formulario completo.',
        'en': '*This information is strongly required. After receiving this form, we will contac the accounts receivables executive.'
    },
    'msgValidacionNacional': {
        'es': 'Autorizo a la empresa Pride Perfomance Fabrics, S. A. de C.V. (PPF) con RTN 05019013550285, con la que tengo relación como proveedor a realizar los depósitos correspondientes a los pagos por concepto de productos entregados y/o servicios prestados.',
        'en': 'I authorize the company Pride Perfomance Fabrics, S. A. de C.V. (PPF) with RTN 05019013550285, with whom I have a relationship as a supplier to make the deposits corresponding to the payments for the products delivered and / or services provided.'
    },
    'parte': {
        'es': 'PARTE',
        'en': 'PART'
    },
    'informacionGeneral': {
        'es': 'Información general',
        'en': 'General information'
    },
    'tipoSolictud': {
        'es': 'Tipo de solicitud',
        'en': 'Type of request'
    },
    'Inscripción': {
        'es': 'Inscripción',
        'en': 'Registration'
    },
    'Actualización': {
        'es': 'Actualización',
        'en': 'Update'
    },
    'cuentaBancariaNacional': {
        'es': 'Dichos depósitos deberán efectuarse en la cuenta No.',
        'en': 'Such deposits must be made in account No.'
    },
    'RTN': {
        'es': 'RTN de la empresa',
        'en': 'Company RTN'
    },
    'CorreoNotificacionPago': {
        'es': 'Correo electrónico para notificación de pagos',
        'en': 'Email for payment notification'
    },
    'Imprimir': {
        'es': 'Imprimir',
        'en': 'Print'
    },
    'ArchivoActual': {
        'es': 'Archivo actual',
        'en': 'Current file'
    },
    'agregarFormatoInscripcion': {
        'es': 'Agregar Formato de inscripción:',
        'en': 'Add Registration Form:'
    },
    'archivoGuardado': {
        'es': 'Archivo guardado',
        'en': 'File saved'
    },
    'descargarArchivoAcutal': {
        'es': 'Descargar archivo actual',
        'en': 'Download current file'
    },
    'aNombreDe': {
        'es': 'A nombre de',
        'en': 'In favor of'
    },
    'ErrorArchivoTamaño': {
        'es': 'No se permiten archivos de 5MB o más.',
        'en': 'Files of 5MB or more are not allowed.'
    },
    'Factura': {
        'es': 'Factura',
        'en': 'Invoice'
    },
    'inforamcionContactoFinanzas':{
        'es': 'Información contacto finanzas',
        'en': 'Finance contact information'
    },
    'Contacto':{
        'es': 'Contacto',
        'en': 'Contact'
    },
    informacionFinanciera: {
      es: "Información financiera",
      en: "Financial information",
    },

    currency: {
      es: "Moneda",
      en: "Currency",
    },

    activos: {
      es: "Activos:",
      en: "Assets:",
    },

    activosCorrientes: {
      es: "Activos corrientes",
      en: "Current assets",
    },

    totalActivos: {
      es: "Total activos",
      en: "Total assets",
    },

    pasivos: {
      es: "Pasivos:",
      en: "Liabilities:",
    },

    pasivosCorrientes: {
      es: "Pasivos corrientes",
      en: "Current liabilities",
    },

    totalPasivos: {
      es: "Total pasivos",
      en: "Total liabilities",
    },

    documentacion: {
      es: "Documentación",
      en: "Documentation",
    },
    nombreLegal: {
      es: "Nombre Legal",
      en: "Legal Name",
    },

    declaracionSituacionFiscalTitulo: {
      es: "Declaración de situación fiscal:",
      en: "Tax status declaration:",
    },

    declaracionSituacionFiscalTexto: {
      es: "Atención, según legislación hondureña (Art. 37-A Código Tributario), si no presenta alguno de estos documentos vigentes:",
      en: "Attention, according to Honduran legislation (Art. 37-A Tax Code), if you do not submit any of these valid documents:",
    },

    registroExoneradosSefin: {
      es: "Registro de Exonerados (SEFIN)",
      en: "Exonerated Registration (SEFIN)",
    },

    constanciaPagosCuentaSar: {
      es: "Constancia de Pagos a Cuenta (SAR)",
      en: "Certificate of Payments on Account (SAR)",
    },

    aplicaremosRetenciones: {
      es: "Aplicaremos retenciones impositivas automáticas.",
      en: "Automatic tax withholdings will be applied.",
    },

    operoZonaLibre: {
      es: "Opero en Zona Libre:",
      en: "I operate in a Free Zone:",
    },

    actualizarInformacion: {
      es: "Actualizar información",
      en: "Update information",
    },

    cuentoConstanciaPagosCuenta: {
      es: "Cuento con Constancia de Pagos a Cuenta vigente",
      en: "I have a valid Certificate of Payments on Account",
    },

    noCuentoRegistroExonerado: {
      es: "No cuento con Registro de Exonerados vigente",
      en: "I do not have a valid Exonerated Registration",
    },

    mensajeRetencionesFiscales: {
      es: "***** Si no presento la Constancia de Pagos a Cuenta o el Registro de Exonerado vigente según sea aplicable, se realizarán las retenciones fiscales correspondientes, conforme a la legislación tributaria de Honduras. *****",
      en: "***** If I do not submit the Certificate of Payments on Account or the valid Exonerated Registration, as applicable, the corresponding tax withholdings will be made in accordance with Honduran tax legislation. *****",
    },

    subirBIC: {
        'es': 'Subir BIC',
        'en': 'Upload BIC'
    },
    subirFactura: {
        'es': 'Subir Factura',
        'en': 'Upload Invoice'
    },
    subirPermiso: {
        'es': 'Subir Permiso de operaciones',
        'en': 'Upload Operations permit'
    },
    subirEscritura: {
        'es': 'Subir Escritura de constitución',
        'en': 'Upload Articles of Incorporation'
    },
    subirConstPagos: {
        'es': 'Subir Constancia de pagos a cuenta',
        'en': 'Upload Proof of payments on account'
    },
    subirRegistroExonerado: {
        'es': 'Subir Registro exonerado',
        'en': 'Upload Exempt registration'
    },
    subirFormatoInscripcion:{
        'es': 'Subir Formato de inscripción',
        'en': 'Upload Registration Form'
    },
    'InformacionFaltante': {
        'es': 'Información Faltante',
        'en': 'Missing Information'
    },
    errorRegistro:{
        es: 'Error al guardar el registro.',
        en: 'Error saving the record.'
    },
    elimineFormatoAnterior:{
        es: 'Elimine el Formato anterior.',
        en: 'Delete the previous format.'
    },
    msgCompleta:{
        es: 'La información se ha guardado exitosamente. Imprima y firme el archivo con el formato de inscripción y luego adjúntelo.',
        en: 'The information has been successfully saved. Print and sign the registration form, then attach the file.'
    },
    InscripcionFinalizada: {
        es: 'La información ha sido guardada exitosamente.',
        en: 'The information has been saved successfully.'
    },

  }